import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import {
    AppBar,
    Avatar,
    Box,
    Button,
    IconButton,
    Menu,
    MenuItem,
    Toolbar,
    Tooltip,
    Typography,
    Switch,
    FormControlLabel,
    Chip,
    Divider
} from '@mui/material';
import {
    Menu as MenuIcon,
    AccountCircle,
    Settings,
    Logout,
    PersonAdd,
    People,
    QrCode,
    Link as LinkIcon,
    AttachMoney
} from '@mui/icons-material';

import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '../Index';
import { useAuth } from '../../contexts/AuthContext';
import { usePaymentMode } from '../../contexts/PaymentModeContext';
import FeeSettingsModal from '../settings/FeeSettingsModal';
import useCurrencyConversion from '../../hooks/useCurrencyConversion';

import logoImage from '../../logo192.png';

// Configurações do menu do usuário
const userMenuItems = [
    { label: 'Perfil', icon: <AccountCircle />, action: 'Perfil' },
    { label: 'Sair', icon: <Logout />, action: 'Sair' }
];

const adminMenuItems = [
    { label: 'Novo Usuário', icon: <PersonAdd />, action: 'novoUsuario' },
    { label: 'Perfis', icon: <People />, action: 'perfis' },
    { label: 'Configurações de Taxas', icon: <AttachMoney />, action: 'configuracoesTaxas' }
];

// Styled components para elementos modernos
const ModernButton = styled(Button)(({ theme }) => ({
    borderRadius: '20px',
    textTransform: 'none',
    fontWeight: 600,
    padding: '8px 20px',
    transition: 'all 0.3s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
}));

const LogoContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
        transform: 'scale(1.05)',
    },
}));

const ModernSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: '#1976D2',
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#1976D2',
    },
}));

export default function Header() {
    const { isLoggedIn, user, logout } = useAuth();
    const { paymentMode, togglePaymentMode } = usePaymentMode();
    const { loadCompanyFeeSettings } = useCurrencyConversion();
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [openFeeSettings, setOpenFeeSettings] = React.useState(false);


    const navigate = useNavigate();
    const location = useLocation();

    // Filtrar rotas baseado no modo de pagamento - mostrar apenas 1 link por vez
    const menuRoutes = routes.filter(route => {
        if (!route.showInMenu) return false;
        if (route.path === 'pix/*' && paymentMode === 'pix') return true;
        if (route.path === 'pagamento' && paymentMode === 'pagamento') return true;
        if (route.path !== 'pix/*' && route.path !== 'pagamento') return true; // Outras rotas sempre aparecem
        return false;
    });

    const titulo = 'PixTick';
    const [key, setKey] = React.useState(0);

    React.useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [location]);

    // Função para obter ícone baseado no modo de pagamento
    const getPaymentModeIcon = () => {
        return paymentMode === 'pix' ? <QrCode /> : <LinkIcon />;
    };

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };


    const handlePageClick = (page) => {
        navigate(`/${page.toLowerCase()}`);
        handleCloseNavMenu();
    };

    const handleLogin = () => {
        navigate('/signin');
    }

    const handleMenuClick = (menuItem) => {
        handleCloseUserMenu();
        switch (menuItem) {
            case 'Perfil':
                handleProfileClick();
                break;
            case 'perfis':
                handleProfilesClick();
                break;
            case 'Account':
                handleAccountClick();
                break;
            case 'Dashboard':
                handleDashboardClick();
                break;
            case 'Sair':
                handleLogoutClick();
                break;
            case 'novoUsuario':
                handleNovoUsuario();
                break;
            case 'configuracoesTaxas':
                handleConfiguracoesTaxas();
                break;
            default:
                break;
        }

    };

    const handleProfileClick = () => {
        // Lógica para lidar com o clique no botão "Profile"
        navigate('/perfil');
        //setOpenAlert(true);
        console.log("Profile clicked");
    };
    const handleProfilesClick = () => {
        // Lógica para lidar com o clique no botão "Profile"
        navigate('/perfis');
        //setOpenAlert(true);
        console.log("Profile clicked");
    };

    const handleAccountClick = () => {
        // Lógica para lidar com o clique no botão "Account"

        console.log("Account clicked");
    };

    const handleDashboardClick = () => {
        // Lógica para lidar com o clique no botão "Dashboard"

        console.log("Dashboard clicked");
    };

    const handleLogoutClick = () => {
        logout();
        navigate('/signin');
    };

    const handleNovoUsuario = () => {
        navigate('/signup');
    }

    const handleConfiguracoesTaxas = () => {
        setOpenFeeSettings(true);
    }

    const handleCloseFeeSettings = () => {
        setOpenFeeSettings(false);
    }

    const handleSettingsUpdated = async () => {
        // Recarregar configurações em todos os componentes que usam o hook
        const token = localStorage.getItem('token');
        if (token) {
            await loadCompanyFeeSettings(token);
        }
    }

    const renderHeaderButtonLogin = () => {
        switch (location.pathname) {
            case '/signin':
                return <></>

            default:
                return (
                    <ModernButton
                        variant="contained"
                        onClick={handleLogin}
                        sx={{
                            backgroundColor: '#FF6700',
                            '&:hover': {
                                backgroundColor: '#E55A00',
                            }
                        }}
                    >
                        Entrar
                    </ModernButton>
                )
        }
    }



    const handleNavigateRelatorioPagamento = () => {
        navigate('/relatorio-pagamento');
    }


    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar
                position="fixed"
                sx={{
                    backgroundColor: '#1976D2',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    backdropFilter: 'blur(10px)',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    // Safe area mais robusto
                    paddingTop: { xs: 'env(safe-area-inset-top, 0px)', sm: 0 },
                    minHeight: { xs: 'calc(64px + env(safe-area-inset-top, 0px))', sm: '64px' },
                    // Fallback para dispositivos sem suporte
                    '@media (max-width: 600px)': {
                        paddingTop: 'max(env(safe-area-inset-top, 0px), 20px)',
                        minHeight: 'calc(64px + max(env(safe-area-inset-top, 0px), 20px))',
                    }
                }}
            >
                <Toolbar sx={{
                    minHeight: { xs: 'calc(64px + env(safe-area-inset-top, 0px)) !important', sm: '64px !important' },
                    paddingTop: { xs: 'env(safe-area-inset-top, 0px)', sm: 0 },
                    // Fallback mais robusto
                    '@media (max-width: 600px)': {
                        paddingTop: 'max(env(safe-area-inset-top, 0px), 20px)',
                        minHeight: 'calc(64px + max(env(safe-area-inset-top, 0px), 20px)) !important',
                    }
                }}>
                    {/* Logo e título - Desktop */}
                    <LogoContainer
                        onClick={handleNavigateRelatorioPagamento}
                        sx={{ display: { xs: 'none', md: 'flex' } }}
                    >
                        <img alt='logo' src={logoImage} width={32} height={32} />
                        <Typography
                            variant="h5"
                            sx={{
                                fontFamily: 'Ubuntu, sans-serif',
                                fontWeight: 700,
                                color: 'white',
                                fontSize: '1.5rem',
                                letterSpacing: '0.5px'
                            }}
                        >
                            {titulo}
                        </Typography>
                    </LogoContainer>

                    {/* Menu Mobile */}
                    {isLoggedIn && (
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="menu"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                                sx={{
                                    backgroundColor: 'rgba(255,255,255,0.1)',
                                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' }
                                }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                keepMounted
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    '& .MuiPaper-root': {
                                        borderRadius: '12px',
                                        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                                        border: '1px solid rgba(255,255,255,0.1)',
                                    }
                                }}
                            >
                                {menuRoutes.map((page) => (
                                    <MenuItem
                                        key={page.name}
                                        onClick={() => handlePageClick(page.path)}
                                        sx={{
                                            py: 1.5,
                                            '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.08)' }
                                        }}
                                    >
                                        <Typography textAlign="center" sx={{ fontWeight: 500 }}>
                                            {page.name}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    )}
                    {/* Logo e título - Mobile */}
                    <LogoContainer
                        onClick={handleNavigateRelatorioPagamento}
                        sx={{ display: { xs: 'flex', md: 'none' }, flexGrow: 1 }}
                    >
                        <img alt='logo' src={logoImage} width={28} height={28} />
                        <Typography
                            variant="h6"
                            sx={{
                                fontFamily: 'Ubuntu, sans-serif',
                                fontWeight: 700,
                                color: 'white',
                                fontSize: '1.2rem',
                                letterSpacing: '0.3px'
                            }}
                        >
                            {titulo}
                        </Typography>
                    </LogoContainer>

                    {/* Links de navegação - Desktop */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, gap: 1, ml: 2 }}>
                        {isLoggedIn && menuRoutes.map((page) => (
                            <ModernButton
                                key={page.name}
                                onClick={() => handlePageClick(page.path)}
                                sx={{
                                    color: 'white',
                                    backgroundColor: 'rgba(255,255,255,0.1)',
                                    '&:hover': {
                                        backgroundColor: 'rgba(255,255,255,0.2)',
                                    }
                                }}
                            >
                                {page.name}
                            </ModernButton>
                        ))}
                    </Box>
                    {/* Menu do usuário */}
                    {isLoggedIn && (
                        <Box sx={{ flexGrow: 0, ml: 2 }}>
                            <Tooltip title="Menu do usuário">
                                <IconButton
                                    onClick={handleOpenUserMenu}
                                    sx={{
                                        p: 0,
                                        '&:hover': {
                                            transform: 'scale(1.1)',
                                            transition: 'transform 0.2s ease'
                                        }
                                    }}
                                >
                                    <Avatar
                                        alt={user.fullname}
                                        src={user.empresaLogo}
                                        sx={{
                                            width: 40,
                                            height: 40,
                                            backgroundColor: user.empresaLogo ? 'transparent' : '#FF6700',
                                            fontWeight: 'bold',
                                            fontSize: '1.1rem',
                                            objectFit: 'cover'
                                        }}
                                    >
                                        {!user.empresaLogo && user.fullname?.charAt(0)?.toUpperCase()}
                                    </Avatar>
                                </IconButton>
                            </Tooltip>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                keepMounted
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                                sx={{
                                    '& .MuiPaper-root': {
                                        borderRadius: '12px',
                                        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                                        border: '1px solid rgba(255,255,255,0.1)',
                                        minWidth: 200,
                                    }
                                }}
                            >
                                {/* Header do menu com nome do usuário */}
                                <Box sx={{ p: 2, textAlign: 'center', borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#1976D2' }}>
                                        {user.fullname}
                                    </Typography>
                                    <Chip
                                        label={user.role}
                                        size="small"
                                        sx={{
                                            mt: 1,
                                            backgroundColor: user.role === 'ADMIN' ? '#FF6700' : '#4CAF50',
                                            color: 'white',
                                            fontSize: '0.7rem'
                                        }}
                                    />
                                </Box>

                                {/* Switch para alternar entre PIX e Pagamento */}
                                <MenuItem sx={{ justifyContent: 'center', py: 2, borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {getPaymentModeIcon()}
                                        <FormControlLabel
                                            control={
                                                <ModernSwitch
                                                    checked={paymentMode === 'pix'}
                                                    onChange={togglePaymentMode}
                                                />
                                            }
                                            label={
                                                <Typography variant="body2" sx={{ fontSize: '0.9rem', fontWeight: 600 }}>
                                                    {paymentMode === 'pix' ? 'Pix' : 'Link'}
                                                </Typography>
                                            }
                                        />
                                    </Box>
                                </MenuItem>

                                {/* Itens do menu admin */}
                                {user.role === 'ADMIN' && adminMenuItems.map((item) => (
                                    <MenuItem
                                        key={item.action}
                                        onClick={() => handleMenuClick(item.action)}
                                        sx={{
                                            py: 1.5,
                                            '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.08)' }
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            {item.icon}
                                            <Typography sx={{ fontWeight: 500 }}>
                                                {item.label}
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                ))}

                                {/* Divider entre admin e usuário */}
                                {user.role === 'ADMIN' && <Divider />}

                                {/* Itens do menu do usuário */}
                                {userMenuItems.map((item) => (
                                    <MenuItem
                                        key={item.action}
                                        onClick={() => handleMenuClick(item.action)}
                                        sx={{
                                            py: 1.5,
                                            '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.08)' }
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            {item.icon}
                                            <Typography sx={{ fontWeight: 500 }}>
                                                {item.label}
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    )}
                    {/* Botão de login para usuários não logados */}
                    {!isLoggedIn && (
                        <Box sx={{ ml: 2 }}>
                            {renderHeaderButtonLogin()}
                        </Box>
                    )}
                </Toolbar>
            </AppBar>

            {/* Modal de Configurações de Taxas */}
            <FeeSettingsModal
                open={openFeeSettings}
                onClose={handleCloseFeeSettings}
                onSettingsUpdated={handleSettingsUpdated}
            />
        </Box>
    );
}
